export const LANGUAGES = {
	FRENCH: 'fr',
	ENGLISH: 'en'
}
